@if (isConsumingToken()) {
<app-auth-shell title="Entrando..." subtitle="Estamos validando seu link de acesso.">
  <div class="auth-confirm">
    <div class="auth-confirm__spinner" role="status" aria-label="Validando link"></div>
  </div>
</app-auth-shell>
} @else if (sentTo(); as email) {
<app-auth-shell title="Verifique seu e-mail" icon="fas fa-envelope-open-text">
  <p class="auth-login__subtitle">
    Se <strong>{{ email }}</strong> estiver cadastrado e confirmado, você receberá um link de acesso de uso único em instantes. Confira também a caixa de spam.
  </p>
  <div class="auth-login__actions">
    <a class="auth-btn" [routerLink]="['/signin']">Voltar para o login</a>
    <p class="auth-login__note">
      Não recebeu o e-mail?
      <button type="button" class="auth-link" (click)="requestLink()" [disabled]="remainingSeconds() > 0">
        @if (remainingSeconds() > 0) { Reenviar em {{ remainingSeconds() }}s } @else { Reenviar }
      </button>
    </p>
    <p class="auth-login__note">
      <button type="button" class="auth-link" (click)="changeEmail()">Usar outro e-mail</button>
    </p>
  </div>
</app-auth-shell>
} @else {
<app-auth-shell title="Entrar sem senha" subtitle="Informe seu e-mail e enviaremos um link seguro para você entrar na hora.">
  <form class="auth-login__form" role="form" [formGroup]="formMagicLink" (ngSubmit)="requestLink()" novalidate>
    <div class="auth-field">
      <label class="auth-field__label" for="email">E-mail</label>
      <div class="auth-field__control">
        <input id="email" type="email" formControlName="email" class="auth-field__input" placeholder="nome@empresa.com" autocomplete="email" appFocus />
      </div>
      @if (formMagicLink.get('email')?.dirty) { @if (formMagicLink.get('email')?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } @if (formMagicLink.get('email')?.hasError('email')) {
      <div class="auth-field__error">E-mail inválido</div>
      } }
    </div>
    <button type="submit" class="auth-btn" [disabled]="!formMagicLink.valid || remainingSeconds() > 0">
      @if (remainingSeconds() > 0) { Reenviar em {{ remainingSeconds() }}s } @else { Enviar link de acesso }
    </button>
  </form>
  <p class="auth-login__signup" authShellFooter>
    Prefere usar a senha?
    <a [routerLink]="['/signin']">Voltar para o login</a>
  </p>
</app-auth-shell>
}
